/**
 * Texture UV coordinate.
 */
export enum TextureCoordinate {
  UV0 = 0,
  UV1,
  UV2,
  UV3,
  UV4,
  UV5,
  UV6,
  UV7
}
